import React from "react";
import Button from "@source/components/UI/buttons/button/button";
import Loader from "@source/components/UI/loader/loader";
import styles from "./consentShared.module.scss";

type RequestStateVariant = "loading" | "error" | "empty";

export interface ConsentRequestStateProps {
  variant: RequestStateVariant;
  title?: string;
  description?: string;
  onRetry?: () => void;
}

const requestStateDefaults: Record<RequestStateVariant, {title: string; description: string}> = {
  loading: {title: "Loading consent records", description: "Please wait a moment."},
  error: {title: "Unable to load consent records", description: "Check your connection and try again."},
  empty: {title: "Nothing here yet", description: "Consent records will appear here when available."},
};

export const ConsentRequestState = ({
  variant,
  title,
  description,
  onRetry,
}: ConsentRequestStateProps) => {
  const content = requestStateDefaults[variant];
  return (
    <div
      className={`${styles.requestState} ${styles[`requestState_${variant}`]}`}
      role={variant === "error" ? "alert" : "status"}
      aria-live="polite"
      aria-busy={variant === "loading"}
    >
      {variant === "loading" ? <Loader width={30} height={30}/> : null}
      <strong>{title || content.title}</strong>
      <span>{description || content.description}</span>
      {variant === "error" && onRetry && <Button variant="outlined" onClick={onRetry}>Try again</Button>}
    </div>
  );
};
